import createVueComponent from '../createVueComponent';
var ChevronUp = createVueComponent('ChevronUpIcon', [['polyline', {
  points: '18 15 12 9 6 15',
  key: '1uugdp'
}]]);
export default ChevronUp;